var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vc-avatar",class:_vm.avaterClass},[_c('img',{attrs:{"src":_vm.src,"alt":"avatar src"}}),(_vm.showBadge)?_c('span',{staticClass:"badge"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }